import {
  ContractorCampaignsPageFilter,
  CAMPAIGN_STATUS_OPTIONS,
  CAMPAIGN_TYPE_OPTIONS,
  getCampaignsOptionsFromInfinite,
  useGetCampaignsInfinityList,
} from 'entities/campaign';
import { useGetServicesOptions, useGetServicesForFilters } from 'entities/service';
import { useMemo } from 'react';
import { FILTER_STYLES } from 'shared/constants';
import { getDataAutoTestAttributes } from 'shared/lib/data-auto-test';
import { MultiSelectWithQueriesUrl, getInfinityListPropsFromQuery } from 'shared/ui/MultiSelect';

export function Filters() {
  const getCampaignsFiltersQuery = useGetCampaignsInfinityList({
    isSyncedWithUrl: false,
    filterName: ContractorCampaignsPageFilter.campaignsIdArray,
    getFieldValueToShow: (item) => item.name,
  });

  const campaignsOptions = useMemo(() => {
    return getCampaignsOptionsFromInfinite(getCampaignsFiltersQuery.data);
  }, [getCampaignsFiltersQuery.data?.pages]);

  const servicesOptions = useGetServicesOptions();
  const servicesFiltersQuery = useGetServicesForFilters();

  return (
    <div className={FILTER_STYLES.container}>
      <MultiSelectWithQueriesUrl.InfinityList
        {...getInfinityListPropsFromQuery(getCampaignsFiltersQuery)}
        rootClassName={FILTER_STYLES.select}
        title="Campaign"
        key="Campaign"
        options={campaignsOptions}
        filterName={ContractorCampaignsPageFilter.campaignsIdArray}
        {...getDataAutoTestAttributes(['input-campaigns-search-by-campaign-name'])}
      />
      <MultiSelectWithQueriesUrl
        rootClassName={FILTER_STYLES.select}
        title="Status"
        options={CAMPAIGN_STATUS_OPTIONS}
        filterName={ContractorCampaignsPageFilter.statusArray}
        {...getDataAutoTestAttributes(['multiselect-campaigns-status'])}
      />
      <MultiSelectWithQueriesUrl.Search
        rootClassName={FILTER_STYLES.select}
        title="Service"
        options={servicesOptions}
        disabled={servicesFiltersQuery.isLoading}
        loading={servicesFiltersQuery.isLoading}
        filterName={ContractorCampaignsPageFilter.serviceIdArray}
        {...getDataAutoTestAttributes(['multiselect-campaigns-service'])}
      />
      <MultiSelectWithQueriesUrl
        rootClassName={FILTER_STYLES.select}
        title="Type"
        options={CAMPAIGN_TYPE_OPTIONS}
        filterName={ContractorCampaignsPageFilter.typeArray}
        {...getDataAutoTestAttributes(['multiselect-campaigns-type'])}
      />
    </div>
  );
}
